import { render, staticRenderFns } from "./user-assessment.vue?vue&type=template&id=69a08060&lang=html"
import script from "./user-assessment.vue?vue&type=script&lang=js"
export * from "./user-assessment.vue?vue&type=script&lang=js"
import style0 from "./user-assessment.vue?vue&type=style&index=0&id=69a08060&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports